import React from "react";
import { AdminTriggerRatingPopupCareReceiverInsertView } from "./view";
import { styles } from "./styles";

export const AdminTriggerRatingPopupCareReceiverInsert = props => (
  <AdminTriggerRatingPopupCareReceiverInsertView {...props} styles={styles} />
);
